import React from "react";
import styled from "styled-components";
import {
    APPLE_MUSIC_SRC_DOMAIN,
    SPOTIFY_SRC_DOMAIN,
    YOUTUBE_SRC_DOMAIN,
} from "@lifeat/shared/widget/MusicPlayerConstants";
import Styles from "@themes/Styles";

const MediaPlayerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    height: 100%;
    width: 100%;

    iframe {
        height: inherit;
        width: inherit;
    }

    border-radius: ${Styles.borderRadiusSharp};
`;

interface MediaPlayerProps {
    readonly contentUrl: string;
}
export default function MediaPlayer(props: MediaPlayerProps) {
    const { contentUrl } = { ...props };

    // Dynamically show the iframe for the Spotify embed, or the error gif if
    // the user's input is invalid.
    let widgetContent;
    if (contentUrl.includes(SPOTIFY_SRC_DOMAIN)) {
        widgetContent = <iframe src={contentUrl} frameBorder="0" allow="encrypted-media" />;
    } else if (contentUrl.includes(APPLE_MUSIC_SRC_DOMAIN)) {
        // iframe embed copied from Apple Music content --> Share --> Copy Embed Code
        widgetContent = (
            <iframe
                allow="autoplay *; encrypted-media *;"
                frameBorder="0"
                style={{ overflow: "hidden", background: "transparent" }}
                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
                src={contentUrl}
            />
        );
    } else if (contentUrl.includes(YOUTUBE_SRC_DOMAIN)) {
        widgetContent = <iframe id="ytplayer" allow="encrypted-media" src={contentUrl} frameBorder="0" />;
    } else {
        widgetContent = <img src={contentUrl} width="100%" height="100%" alt={"Content not found gif of crab."} />;
    }

    return <MediaPlayerWrapper>{widgetContent}</MediaPlayerWrapper>;
}
